export default __webpack_public_path__ + "img/sabira_logo_full.9adc869a.svg";